import {
   randNumber,
   randUserName,
   randFirstName,
   randLastName,
   randAvatar,
   randEmail,
   randJobTitle,
   randPhoneNumber,
} from '@ngneat/falso';
import { optional } from '@library/common/functions';

import { MockAccount } from './account.mock';
import { AllServices } from '../useraccess';
import { MockPinnedReport } from './pinned-report.mock';
import { User } from '../user/user';

export class MockUser extends User {
   constructor( opts?: { skipReports?: boolean }) {
      super();

      this.username = randUserName();
      this.fname = optional( 70 ) ? randFirstName() : '';
      this.lname = optional( 70 ) ? randLastName() : '';
      if ( optional()) { this.avatar = randAvatar(); }
      this.email = randEmail();
      this.title = optional() ? randJobTitle() : '';
      this.phone = optional() ? randPhoneNumber() : '';

      this.services = AllServices;
      // this.services = AllServices.filter( s => s.includes( 'booking' ) ? optional() : true );
      // this.services = AllServices.filter( s => optional() );

      this.accounts = Array.from({ length: randNumber({ min: 1, max: 40 })}, _ => new MockAccount() );
      if ( this.accounts.length ) {
         this.accounts[0].primary = true;
         this.accounts[0].active = true;
      }
      if ( !opts?.skipReports ) {
         this.pinned_reports = Array.from({ length: Math.random() * 10 + 1 }, _ => new MockPinnedReport() );
      }
      this.preferences = JSON.parse( sessionStorage.getItem( 'prefs' ) || '{}' );
   }
}
